import { Injectable } from '@angular/core';
import { HashLocationStrategy } from '@angular/common';

@Injectable()
export class AppLocationStrategy extends HashLocationStrategy {
  prepareExternalUrl(internal: string): string {
    // console.log('internal: ' + internal);
    const url = this.getBaseHref() + '#' + internal;
    return url;
  }
}



// WEBPACK FOOTER //
// ./src/app/app-location-strategy.service.ts